import FormService from "../../services/FormService";
import SelectPicker from "../../components/SelectPicker";
import FormInput from "../../components/FormInput";
export default {
    components: {SelectPicker, FormInput},
    data() {
        return {
            form: new FormService({
                code: null,
                name: '',
                name_uz: '',
                name_en: '',
                lat: null,
                lng: null,
                parent_id: null,
                status: 10,
                id: null
            }),
            statuses: [
                {
                    id: 10,
                    text: 'Актив'
                },
                {
                    id: 5,
                    text: 'Выключено'
                },
            ],
            center: {lat: 41.311081, lng: 69.240562},
            location: {lat: 41.311081, lng: 69.240562},
            address: null,

            for_validate: {
                code: "Code",
                name: this.i18n('Title'),
                name_uz: "Nomi",
                name_en: "Name",
                regular_errors: {
                    name: this.i18n('cyrillic letters'),
                    name_uz: this.i18n('latin letters'),
                    name_en: this.i18n('latin letters'),
                }
            }
        }
    },
    methods: {
        getFormData() {
            let id = this.$route.params['id'];
            if (id) {
                this.$api.get('locations.show', id)
                    .then(res => {
                        if (!res.errors) {
                            this.form.setData(res.data);
                        }
                    })
            }
        },
        updateForm(navigate = false) {
            if(!this.validateName()){
                return false;
            }
            this.form.put('locations.update', this.form.id)
                .then(res => {
                    if (!res.errors) {
                        this.successNotify();
                        if (navigate) {
                            this.$router.push({name: 'locations'});
                        }
                    }
                })
        },
        createForm(navigate = false) {
            if(!this.validateName()){
                return false;
            }

            this.form.post('locations.create')
                .then(res => {
                    if (!res.errors) {
                        this.successNotify();
                        if (navigate) {
                            this.$router.push({name: 'locations'});
                        } else {
                            this.form.reset();
                        }
                    }
                })
        },
        successNotify() {
            this.$notify({
                type: 'success',
                group: 'foo',
                title: 'Успешно!!!',
                text: 'Сохранено!'
            });
        },
        setPlace(place) {
            let lat = parseFloat(place.geometry.location.lat());
            let lng = parseFloat(place.geometry.location.lng());
            this.form.lat = this.center.lat = lat;
            this.form.lng = this.center.lng = lng;
        },
        setAndGetMarkerLocation(event){
            this.location = event.latLng;
            this.form.lat = this.location.lat();
            this.form.lng = this.location.lng();
            let geocoder = new google.maps.Geocoder;
            geocoder.geocode({'location': this.location}, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        this.address = results[0].formatted_address;
                    }
                }
            });
        },

        validateName(){
            try{
                this.validateNameRu()
                this.validateNameUz()
                this.validateNameEn()
                return true;
            }catch(error){
                this.$store.commit("errorNotifyByText", error)
                return false
            }
        },
        validateNameRu(){
            let reg = /^[А-ЯЁа-яё\-\'\s]*$/
            this.validateNameDefault(reg, "name", true)
        },
        validateNameUz(){
            let reg = /^[A-Za-z\-\'\s]*$/
            this.validateNameDefault(reg, "name_uz")
        },
        validateNameEn(){
            let reg = /^[A-Za-z\-\'\s]*$/
            this.validateNameDefault(reg, "name_en")
        },
        validateNameDefault(reg, name, required = false){
            let form = this.form;
            form[name].trim();

            if(required && !form[name]){
                throw this.for_validate[name] + ": "+this.i18n('required field')+" "
            }

            if(!form[name].match(reg)){
                throw this.for_validate[name] + ": "+this.i18n('can only be used')+" "+this.for_validate.regular_errors[name]
            }

            if(required && form[name].length < 3){
                throw this.for_validate[name] + ": "+this.i18n('minimum length is 3')
            }

            if(form[name].length > 150){
                throw this.for_validate[name] + ": "+this.i18n('maximum length is 150')
            }


        }
    },
    created() {
        this.getFormData();
    }
}
